let _setAuth = null;
let _getAuth = null;

export const registerSetAuth = (setter) => {
  _setAuth = setter;
};

export const registerGetAuth = (getter) => {
  _getAuth = getter;
};

export const setRecoilAuth = (auth) => {
  if (_setAuth) _setAuth(auth);
};

export const getRecoilAuth = () => {
  return _getAuth ? _getAuth() : null;
};
